import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective, BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SubSink } from 'subsink';
import { Router } from '@angular/router';

import { CommonUtilsService } from '../shared/services/common-utils.service';
import { FetchJsonService } from '../shared/services/fetch-json.service';
import { ForgotPasswordService } from './services/forgot-password.service';
import { AppStorage, MessageFor } from '../providers/enum';
import { forgotPasswordAction } from '../providers/constant';
import { RegisterComponent } from '../register/register.component';
import { LoginComponent } from '../login/login.component';
import { StorageService } from '../shared/services/storage.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  //#region variables

  @ViewChild('loginTemplate') public loginTemplate: ModalDirective;

  public forgotPasswordMessage: any;
  public errorMessage: string;
  public isProcessCompleted = false;
  public isCheckValidation = false;
  public forgotPasswordFormGroup: FormGroup;
  public streamDetails;
  public showLoading: boolean;
  private subs = new SubSink();

  //#endregion

  //#region life-cycle hook

  constructor(
    private formBuilder: FormBuilder,
    private fetchJsonService: FetchJsonService,
    private modalRef: BsModalRef,
    private router: Router,
    private modalService: BsModalService,
    private storageService: StorageService,
    private forgotPasswordService: ForgotPasswordService) { }

  ngOnInit(): void {
    let details = this.storageService.get(AppStorage.streamDetails, true);
    this.streamDetails = JSON.parse(details);
    this.getForgotPasswordMessage();
    this.createForgotPasswordFormGroup();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  //#endregion

  //#region private methods

  private getForgotPasswordMessage(): void {

    this.subs.sink = this.fetchJsonService.getMessagesList()
      .subscribe((messageList) => {
        this.forgotPasswordMessage = messageList[MessageFor.ForgotPasswordForm];
      });
  }

  private createForgotPasswordFormGroup(): void {
    this.forgotPasswordFormGroup = this.formBuilder.group({
      email: [null, [Validators.required]]
    }, {
      validator: [
        CommonUtilsService.checkEmail('email', true)
      ]
    });
  }

  //#endregion

  //#region public methods

  public get forgotPasswordControls() { return this.forgotPasswordFormGroup.controls; }

  public onCancel(): void {
    this.modalRef.hide();
  }

  public onForgotPasswordClick(): void {
    if (this.forgotPasswordFormGroup.invalid) {
      return;
    }

    this.showLoading = true;

    this.isCheckValidation = true;
    let appCode = this.storageService.get(AppStorage.appCodeLS, true);
    const formData = new FormData();
    formData.append("emailOrusername", this.forgotPasswordControls.email.value);
    //formData.append("appId", appCode);
    formData.append("appId", appCode);
    formData.append("postAction", forgotPasswordAction);

    this.subs.sink = this.forgotPasswordService.forgotPassword(formData)
      .subscribe(
        (authResponse: any) => {
          if (authResponse.status) {
            this.isProcessCompleted = true;
            this.errorMessage = "New password has been sent to your registered email address.";
          } else {
            this.isProcessCompleted = false;
            this.errorMessage = "Sorry, given email address is not present in our record.";
          }
          this.showLoading = false;
        },
        (error) => {
          this.isProcessCompleted = false;
         // console.log('error: ', error);
         this.showLoading = false;
        }
        
      );
  }

  public onLoginClick(): void {
    this.onCancel();
    this.modalRef = this.modalService.show(
      LoginComponent,
      Object.assign({ignoreBackdropClick: true}, { class: 'gray modal-md' })
    );
  }

  public onCreateAccount(): void {
    this.onCancel();
    this.modalRef = this.modalService.show(
      RegisterComponent,
      Object.assign({ignoreBackdropClick: true}, { class: 'gray modal-md' })
    );
  }

  //#endregion

}
